import { Modal as AntdModal, ModalProps as AntdModalProps } from 'antd'

export interface ModalProps extends AntdModalProps {}

const Modal: React.FC<ModalProps> = (props) => {
  return <AntdModal maskClosable={false} destroyOnClose {...props} />
}

export default Modal
